export const isAuthError = (err) => {
    if (err?.response?.status === 401) return true;

    if (err?.response?.status === 403) {
        const message = err?.response?.data?.message || '';
        return message.toLowerCase().includes('access denied');
    }

    return false;
}